module.exports = __webpack_public_path__ + "img/tng.66a3238e.png";